import { EnvironmentConfig } from '@shared/interfaces/environment-config';
import { Environment } from '@shared/interfaces/environment';
import { CountryCode } from '@shared/enums/coutry-code';

export function environmentConfigFactory(environment: Environment): EnvironmentConfig {
  const hostname = window.location.hostname.split('.');
  const ext = hostname.length > 2 ? hostname[hostname.length - 1] : hostname[1];

  if (Object.values(CountryCode).includes(ext as CountryCode)) {
    switch (ext) {
      case 'com':
        return environment.langs['fr'];
      default:
        // @ts-ignore
        return environment.langs[ext as CountryCode] && Object.keys(environment.langs[ext as CountryCode]).length > 0
          ? environment.langs[ext as CountryCode]
          : environment.langs['fr'];
    }
  } else {
    return environment.langs['fr'];
  }
}
